export const selectHasApprovalFeature = (state) =>
  state?.organizations?.selected?.hasApprovalFeature;

export const selectHasFirstCommentEntitlement = (state) =>
  state?.organizations?.selected?.hasFirstCommentFeature;

export const selectCurrentOrganizationId = (state) =>
  state?.organizations?.selected?.id;

export const selectHasFeature = (state, feature) =>
  state?.organizations?.selected?.[feature] || false;

export const selectHasContentFeature = (state) =>
  state?.organizations?.selected?.hasContentFeature;

export const selectShouldShowNBMigration = (state) =>
  state?.organizations?.selected?.shouldShowNBMigrationModal;
